
seedWebApp.controller('SettingsController', ['$scope', '$rootScope', '$window', '$route',
    function ($scope, $rootScope, $window, $route) {

        $rootScope.moduleName = 'Ajustes';
        var tab = $route.current.$$route.tab;

        $scope.settings = [            
            //{ name: 'status', display: 'Status', url: '/Settings/Status/', isVisible: 'Status' },                
            { name: 'users', display: 'Users', url: '/Settings/Users/', isVisible: 'Users' },
            { name: 'emails', display: 'Emails', url: '/Settings/Emails/', isVisible: 'DocTypes' },
            { name: 'docs', display: 'Docs', url: '/Settings/Docs/', isVisible: 'DocTypes' },
            { name: 'stages', display: 'Stages', url: '/Settings/Stages/', isVisible: 'DocTypes' },
            { name: 'plants', display: 'Plants', url: '/Settings/Plants/', isVisible: 'Plantas' },
            { name: 'dbUpdater', display: 'DBUpdater', url: '/Settings/DBUpdater/', isVisible: 'DBUpdater' },
        ];

        $scope.selectSetting = function (page) {
            console.log('selectSetting ' + page);

            if ($scope.isMobile)
                $scope.pageSelected = true;
            else if (page == 'none') {
                for (var i = 0; i < $scope.settings.length; i++) {
                    page = $scope.settings[i].name;
                    break;
                }
            }
            if (page) {
                $scope.settingPage = page;
                switch (page) {
                    case 'users':
                        $scope.settingName = $scope.translation.Users;
                        break;
                    case 'contacts':
                        $scope.settingName = $scope.translation.Clients;
                        break;
                    case 'dbUpdater':
                        $scope.settingName = $scope.translation.DBUpdater;
                        break;
                }
            }
        };

        $scope.$watch('modules', function (newValue) {
            if ($scope.modules && !$scope.isMobile) {
                $scope.selectSetting(tab);
            }
        });

        if (window.innerWidth < 500) {
            $scope.isMobile = true;
            $scope.pageSelected = false;
        } else {
            $scope.isMobile = false;
            $scope.selectSetting(tab);
        }

        $scope.onScroll = function (id) {
            var element = document.getElementById(id);
            var topPosition = element.offsetTop;
            if (topPosition > 0) {
                return true;
            }
            return false;       
        };

        $scope.scrollTop = function (id) {
            document.getElementById(id).scrollTop = 0;
        };

        $scope.AdjustSize = function () {
            //console.log('AdjustSize');
            //var innerHeight = Math.max(0, window.innerHeight) - 137;
            var innerHeight = Math.max(0, window.innerHeight) - 70;
            var height = innerHeight - (innerHeight * 0.02);

            //setSize('contacts', height);
            /*
            setSize('userSettings', height);
            setSize('userRoles', height);    
            */
            //setSize('userCustomers', height);
            //setSize('userInvitations', height);
         
            //return height - 30;
            return height - 28;
        }

        //function setSize(name, height) {
        //    if (document.getElementById(name)) {
        //        console.log('Adjusting size ' + name);
        //        document.getElementById(name).style.height = height + 'px';
        //    }
        //    else {
        //        console.log('setSize, element not found ' + name);
        //    }
        //}

        $window.onresize = function (event) {           
            $scope.overflowSize = $scope.AdjustSize();
        };

        $(document).ready(function () {            
            $scope.overflowSize = $scope.AdjustSize();
        });

        $scope.goBack = function () {
            $scope.pageSelected = false;
        };
}]);
